﻿import { SelectRoles } from 'components/SelectRoles/SelectRoles';
import { type UserPermissions } from 'pages/users/types';
import { PartnerPermissions } from 'pages/partners';
import { useUsers } from 'pages/users/context';
import { useSuperState } from 'hooks';
import { User } from 'apis/UsersApi';

import 'pages/users/components/Permissions/styles/permissions.scss';

type PermissionProps = {
    handleUserUpdate?: (userDetails: User) => void
    permissions: UserPermissions | PartnerPermissions;
    userDetails: User;
};

export const Permissions = (props: PermissionProps) => {

    const { handleUserUpdate, permissions, userDetails } = props;

    const [state, setState] = useSuperState({
        newPermissionList: (userDetails?.Permissions?.map(permission => permission.PermissionId) ?? []) as string[]
    });
    const { newPermissionList } = state;

    const { currentPartnerId } = useUsers();

    return (
        <div className="permissions">
            <SelectRoles
                handlerType="Update"
                handleUserUpdate={handleUserUpdate}
                newPermissionList={newPermissionList}
                partnerId={currentPartnerId}
                permissions={permissions}
                setNewPermissionList={val => setState({ newPermissionList: val })}
                user={userDetails}
            />
        </div>
    );

};
